function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.3 10.13c.28 1.1-.21 2.12-1.05 2.64v1.98a1.25 1.25 0 01-2.5 0v-1.98a2.373 2.373 0 01-1.13-2.02c0-1.52 1.44-2.7 3.02-2.28.8.21 1.45.86 1.66 1.66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25c4.74 0 8.86 3.04 10.27 7.55.12.4-.1.82-.49.94-.4.12-.82-.1-.94-.49a9.205 9.205 0 00-8.83-6.5c-5.1 0-9.25 4.15-9.25 9.25s4.15 9.25 9.25 9.25a9.2 9.2 0 008.82-6.47c.12-.4.54-.61.94-.49.4.12.61.55.49.94-1.42 4.5-5.54 7.52-10.26 7.52z"
})));